export default __webpack_public_path__ + "static/media/discover.f7d9feba.png";